import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import './scss/main.scss'
import BookNow from './pages/BookNow'
import CompleteBooking from './pages/CompleteBooking'
import Home from './pages/Home'
import Login from './pages/Login'
import MyTransfers from './pages/MyTransfers'
import BookingReview from './pages/BookingReview'
import ProfileSettings from './pages/ProfileSettings'
import Register from './pages/Register'
import PasswordReset from './pages/PasswordReset'
import AuthenticatedRoute, { AuthenticatedRouteProps } from './components/AuthenticatedRoute'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from './store'
import Billing from './pages/Billing'
import ScrollToTop from './components/ScrollToTop'
import { PageURLs } from './common'
import AddTransfer from './pages/AddTransfer'
import PasswordEmail from './pages/PasswordEmail'
import useAuth from './hooks/useAuth'
import { logout, logError } from './store/slices/app'
import OrderConfirmation from './pages/OrderConfirmation'

function App() {
  const isAuthenticated = useSelector((state: RootState) => state.app.authenticated)
  const protectedRouteProps: AuthenticatedRouteProps = {
    isAuthenticated,
    authenticationPath: '/login',
  }

  const auth = useAuth()
  const dispatch = useDispatch()

  // On initial load, check they are actually logged in
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        await auth.profile()
      } catch (err) {
        dispatch(logError(err))
        dispatch(logout())
      }
    }

    if (isAuthenticated) {
      fetchProfile()
    }
  }, [])

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Switch>
        <Route {...protectedRouteProps} exact path="/" component={Home} />
        <AuthenticatedRoute
          {...protectedRouteProps}
          exact
          path={PageURLs.ProfileSettings}
          component={ProfileSettings}
        />
        <AuthenticatedRoute {...protectedRouteProps} exact path={PageURLs.Transfers} component={MyTransfers} />
        <AuthenticatedRoute {...protectedRouteProps} exact path={PageURLs.Billing} component={Billing} />

        {/* Authentication Routes */}
        <Route exact path={PageURLs.Login} component={Login} />
        <Route exact path={PageURLs.Register} component={Register} />
        <Route exact path={PageURLs.PasswordEmail} component={PasswordEmail} />
        <Route exact path={PageURLs.PasswordReset} component={PasswordReset} />

        {/* Purchasing / Checkout */}
        <Route exact path={PageURLs.BookNow} component={BookNow} />
        <Route exact path={PageURLs.AddTransfer} component={AddTransfer} />
        <Route exact path={PageURLs.CompleteBooking} component={CompleteBooking} />
        <Route exact path={PageURLs.BookingReview} component={BookingReview} />
        <Route exact path={PageURLs.OrderConfirmation} component={OrderConfirmation} />
      </Switch>
    </BrowserRouter>
  )
}

export default App
